/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-11 11:27:51
 * @LastEditors: Json Chen
 * @LastEditTime: 2021-06-22 17:36:20
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorHomepage/common.ts
 */
export enum EnumCollapseId {
  iconStyle = 'saleChannelContentHomepageIconStyle',
  seoSetting = 'saleChannelContentHomepageSeoSetting',
  floatingBar = 'saleChannelContentHomepageFloatingBar',
  miniProgramShare = 'saleChannelContentHomepageMiniProgramShare',
  miniProgramPageInfo = 'saleChannelContentHomepageMiniProgramInfo',
}
